import ProfileHeader from "../pages/Components";
import { useState } from "react";
import { useEffect } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import axios from "axios";
import edit from "/webapps/carwash_landing/src/assets/edit-text.png";
import deletee from "/webapps/carwash_landing/src/assets/Frame 1770.png";
import Modal from "react-modal";
import view from "/webapps/carwash_landing/src/assets/view-icon.png";
import { useToken } from "../components/TokenContext";

export default function Packages() {
  const { token } = useToken();
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [deletePackageName, setDeletePackageName] = useState(null);
  const history = useHistory();

  const openModal = (packageName) => {
    setDeletePackageName(packageName);
    setIsOpen(true);
    console.log(packageName)
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    axios
      .get("https://carwashapis.gosmart.ae/get_all/carwash_package",{
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => setData(res.data.data))
      .catch((err) => console.log(err));
  }, []);

  const handleCheckboxChange = (id) => {
    const selectedIndex = selectedItems.indexOf(id);
    if (selectedIndex === -1) {
      setSelectedItems([...selectedItems, id]);
    } else {
      setSelectedItems(selectedItems.filter((item) => item !== id));
    }
  };

  const handleDelete = (packageName) => {
    const payload = {
      package_name: packageName,
      flag: true
    };

    console.log("Deleting package with payload:", payload);

    axios
      .post("https://carwashapis.gosmart.ae/delete_package", payload ,{
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        console.log("Delete response:", res);
        setData(data.filter((d) => d.package_name !== packageName)); // Remove the deleted package from the data array
        setIsOpen(false); // Close the modal
      })
      .catch((err) => {
        console.log("Error deleting package:", err);
        console.log("Error response:", err.response);
      });
  };

  return (
    <div>
      <ProfileHeader />
      <h1 className="updateuser">Packages</h1>

      <div className="d-flex justify-content-end">
        <span className="adduserbtn">
          <Link to="/addpackage">+ Add Package </Link>
        </span>
      </div>

      <table className="table shadow">
        <thead>
          <tr className="shadow">
            <th scope="col">Package Name</th>
            <th scope="col">Package Active </th>
            <th scope="col">is Archive</th>
            <th scope="col">Actions</th>
          </tr>
        </thead>
        <tbody>
          {data.map((d, i) => (
            <tr key={i}>
              <td>{d.package_name}</td>
              <td>
                <input
                  type="checkbox"
                  className="updateinputs"
                  checked={d.package_active}
                  onChange={() => handleCheckboxChange(d.id)}
                />
              </td>
              <td>
                <input
                  type="checkbox"
                  className="updateinputs"
                  checked={d.is_archive}
                  onChange={() => handleCheckboxChange(d.id)}
                  disabled={true}
                />
              </td>
              <td>
                <Link to={`/packageinfo/${d.id}`}>
                  <button className="btn btn-sm readbtn ">
                    <img src={view} className="viewicon" />
                  </button>
                </Link>
                <Link to={`/Updatepackage/${d.id}`}>
                  <button className="btn btn-sm editbtn ">
                    <img src={edit} className="editbackground" />
                  </button>
                </Link>
                <button
                  className="btn btn-sm deletebtn"
                  onClick={() => openModal(d.package_name)}
                >
                  <img src={deletee} className="editbackground" />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <Modal
        isOpen={isOpen}
        onRequestClose={closeModal}
        contentLabel="Example Modal"
        className="Modal shadow"
      >
        <h2>Confirm Delete</h2>
        <p>Are you sure you want to delete this record?</p>
        <div className="btns">
          <button
            className="Confirm"
            onClick={() => {
              handleDelete(deletePackageName);
              setIsOpen(false);
            }}
          >
            Confirm
          </button>
          <button className="cancel" onClick={closeModal}>
            Cancel
          </button>
        </div>
      </Modal>
    </div>
  );
}
